import User from './user'
import payment from './payment'
import TaskList from './task-list'
import Event from './event'
import Team from './team'
import Message from './message'
import Test from './test'
import Common from './common'
import SuperQuiz from './super-quiz'
import Tdpt from './Tdpt'
import eventPlaza from './event-plaza'
import naqt from './naqt'
import authentication from './authentication'
import society from './society'

export default {
  ...User,                // 个人类
  ...payment,             // 支付类
  ...TaskList,            // 任务列表类
  ...Event,               // 赛事详情
  ...Message,             // 消息
  ...Test,                // 考试类
  ...Team,                // 组队
  ...Common,              // 公共接口
  ...SuperQuiz,           // super-quiz考试
  ...eventPlaza,          // 活动广场
  ...naqt,                // naqt
  ...Tdpt,                // 第三方认证
  ...authentication,      // 学生认证
  ...society              // 俱乐部内容
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/index.js